export default [
  {
    url: '/management/officer',
    label: 'Petugas',
    icon: 'officer'
  },
  {
    url: '/management/organization',
    label: 'Organisasi',
    icon: 'organization'
  },
  {
    url: '/management/shelter',
    label: 'Penampungan',
    icon: 'shelter'
  },
  {
    url: '/management/logistic',
    label: 'Barang Logistik',
    icon: 'logistic',
    children: [
      {
        url: '/management/logistic/storage',
        label: 'Gudang Logistik'
      },
      {
        url: '/management/logistic/distribution',
        label: 'Distribusi Logistik'
      }
    ]
  },
  {
    url: '/management/heavy-tool',
    label: 'Alat Berat',
    icon: 'heavy-tool',
    children: [
      {
        url: '/management/heavy-tool/storage',
        label: 'Gudang Alat Berat'
      },
      {
        url: '/management/heavy-tool/distribution',
        label: 'Distribusi Alat Berat'
      }
    ]
  },
  {
    url: '/management/automated-message',
    label: 'Pesan Otomatis',
    icon: 'automated-message'
  }
]